import { removeToken } from 'helpers';

export const allClear = () => async (dispatch) => {
    removeToken();
    window.location.href = `//${window.location.host}${process.env.PUBLIC_URL}/login`;
}
